export enum OperatorEnum {
    OperatorEqual = 'eq',
    OperatorIn ='in',
    OperatorContain = 'cn',
    OperatorGreaterThan = 'gt',
    OperatorLowerThan = 'lt',
    OperatorGreaterEqualsThan = 'ge',
    OperatorLowerEqualsThan = 'le',
    OperatorStartWith = 'sw',
    OperatorEndWith = 'ew',
    OperatorIsOrNotNull = 'is',
    OperatorValidatedUpdated = 'vu'
} 

export class OperatorUtil {
    static getOperator(item: string): string {
        return item.substring(0, item.indexOf(':'));
    }

    static getText(item: string): string {
        return item.substring(item.indexOf(':') + 1);
    }
}